import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'

const WraaperTabD = muiThemeable()(
  ({
    muiTheme: {
      palette: {
        borderColor,
      },
    },
    children,
  }) => (
    <div
      style={{
        display: 'flex',
        backgroundColor: '#ffffff',
        border: `1px solid ${borderColor}`,
        borderRadius: 3,
        overflow: 'hidden',
        cursor: 'pointer',
      }}
    >
      {children}
    </div>
  ),
)

WraaperTabD.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]).isRequired,
}

export default WraaperTabD



// WEBPACK FOOTER //
// ./src/components/Tabs/WrapperTabs/WrapperTabD.js